import styled from 'styled-components';

import { StyledDropdownWrapper } from '@/components/Dropdown/StyledDropdownWrapper';

export const NestedDropdownWrapper = styled(StyledDropdownWrapper)`
  ${({ $fullwidth }) => ($fullwidth ? 'width: 100%;' : 'width: max-content;')};
`;
